import { createPortal } from 'react-dom';
import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import { useDispatch } from 'react-redux';
import { setModalState } from '@actions/quizTaking';
import { MODAL_TYPES } from '@cont/Quiz/constants';
import DraggableCalculator from '@cont/Quiz/Taking/Common/DraggableCalculator';
import { getModalState } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const RevampedModals = Dynamic(() =>
  import('@cont/Quiz/RevampedTaking/Modals')
);

const CalculatorLayer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  pointer-events: none;

  & > div {
    pointer-events: auto;
  }
`;

const NtaModals = () => {
  const dispatch = useDispatch();
  const modalState = useSelectorWithShallowEqual(getModalState);
  const showCalculator = modalState?.type === MODAL_TYPES.QUIZ_CALCULATOR;

  const resetModal = () => {
    dispatch(
      setModalState({
        type: null,
        data: {}
      })
    );
  };

  const calculatorPortal =
    showCalculator && typeof document !== 'undefined'
      ? createPortal(
          <CalculatorLayer>
            <DraggableCalculator
              type={modalState.data.calculatorType}
              show={showCalculator}
              onClose={resetModal}
              isTestRevampFlow={false}
            />
          </CalculatorLayer>,
          document.body
        )
      : null;

  return (
    <>
      <RevampedModals />
      {calculatorPortal}
    </>
  );
};

export default NtaModals;
